// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__35kvf","subheader":"ReorderModal_subheader__2Hunu","listWrap":"ReorderModal_listWrap__C51j_"};